import EventEmitter from './EventEmitter'

export function prefillMessage(message) {
  EventEmitter.emit('prefillMessage', message)
}
